import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import {
  Box,
  Container
} from '@material-ui/core';

import ReturnOrderListResults from 'components/ReturnOrders/ReturnOrderListResults';

const mapStateToProps = (state) => ({
  activeUserId: state.activeUserId,
  products: state.products,
  vendors: state.vendors,
  returnOrders: state.returnOrders,
  idGen: state.idGen,
  user: state.user
});

const ReturnOrderList = (props) => (
  <>
    <Helmet>
      <title>Return Orders | Duot One</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container maxWidth={false}>
        <ReturnOrderListResults
          activeUserId={props.activeUserId}
          products={props.products}
          vendors={props.vendors}
          returnOrders={props.returnOrders}
          idGen={props.idGen}
          user={props.user}
        />
      </Container>
    </Box>
  </>
);

export default connect (mapStateToProps) (ReturnOrderList);